import { md5 } from 'js-md5';
import { PropertyPath, set } from 'lodash';
import { makeAutoObservable } from 'mobx';
import * as userApi from 'src/api/user';
import { getBackendDomain } from 'src/utils/common';

const USER_BASE_INFO = 'USER_BASE_INFO';
const BASE_PREFIX = process.env.REACT_APP_BASE_PREFIX;
const BASE_PREFIXS =
  process.env.REACT_APP_BASE_PREFIX === '/' ? '' : process.env.REACT_APP_BASE_PREFIX;
class CommonStore {
  baseInfo?: null | any;

  promptInfo?: null | any;

  // 定义一个对象来存储每个样式枚举的图片路径和平台名字
  styleConfigs = {
    GREEN: {
      logo: [`${BASE_PREFIXS}/images/style/shuzi_logo.png`],
      loginLogo: `${BASE_PREFIXS}/images/style/shuzi_login_logo.png`,
      // platformName: '一体化数字营销平台',
      headerImage: `${BASE_PREFIXS}/images/style/shuzi_head.png`,
      sidebarImage: `${BASE_PREFIXS}/images/style/shuzi_sidebar.png`,
      loginBackground: `${BASE_PREFIXS}/images/style/shuzi_login_bg.png`,
      themeColor: '#386B62',
      homeBgPaths: [
        `${BASE_PREFIXS}/images/style/shuzi_shouye_01.png`,
        `${BASE_PREFIXS}/images/style/shuzi_shouye_02.png`,
        `${BASE_PREFIXS}/images/style/shuzi_shouye_03.png`,
      ],
      welcomePageBg: `${BASE_PREFIXS}/images/style/green_welcome.png`,
      title: '欢迎登录',
      subTitle1: '精准触达目标用户',
      subTitle2: '高效执行营销策略',
    },
    BLUE: {
      logo: [`${BASE_PREFIXS}/images/style/zhihui_logo.png`],
      loginLogo: `${BASE_PREFIXS}/images/style/zhihui_login_logo.png`,
      // platformName: '智慧营销平台',
      headerImage: `${BASE_PREFIXS}/images/style/zhihui_header.png`,
      sidebarImage: `${BASE_PREFIXS}/images/style/zhihui_sidebar.png`,
      loginBackground: `${BASE_PREFIXS}/images/style/zhihui_login_bg.png`,
      themeColor: '#2675f6',
      homeBgPaths: [
        `${BASE_PREFIXS}/images/style/zhihui_shouye_01.png`,
        `${BASE_PREFIXS}/images/style/zhihui_shouye_02.png`,
        `${BASE_PREFIXS}/images/style/zhihui_shouye_03.png`,
      ],
      welcomePageBg: `${BASE_PREFIXS}/images/style/blue_welcome.png`,
      title: '欢迎使用',
      subTitle1: '每一次登录都是新的起点',
      subTitle2: '每一次操作都有更好的结果',
    },
    DARK_BLUE: {
      logo: [`${BASE_PREFIXS}/images/style/quanyi_logo.png`],
      loginLogo: `${BASE_PREFIXS}/images/style/quanyi_login_logo.png`,
      // platformName: '权益通智慧平台',
      headerImage: `${BASE_PREFIXS}/images/style/quanyi_head.png`,
      sidebarImage: `${BASE_PREFIXS}/images/style/quanyi_sidebar.png`,
      loginBackground: `${BASE_PREFIXS}/images/style/quanyi_login_bg.png`,
      themeColor: '#373B94',
      homeBgPaths: [
        `${BASE_PREFIXS}/images/style/quanyi_shouye_01.png`,
        `${BASE_PREFIXS}/images/style/quanyi_shouye_02.png`,
        `${BASE_PREFIXS}/images/style/quanyi_shouye_03.png`,
      ],
      welcomePageBg: `${BASE_PREFIXS}/images/style/darkblue_welcome.png`,
      title: '登录成功',
      subTitle1: '智能化用户运营',
      subTitle2: '可视化效果展示',
    },
    WHITE: {
      logo: [`${BASE_PREFIXS}/images/style/baoxian_logo.png`],
      loginLogo: `${BASE_PREFIXS}/images/style/baoxian_login_logo.png`,
      // platformName: '保险通营销平台',
      headerImage: `${BASE_PREFIXS}/images/style/baoxian_head.png`,
      sidebarImage: `${BASE_PREFIXS}/images/style/baoxian_sidebar.png`,
      loginBackground: `${BASE_PREFIXS}/images/style/baoxian_login_bg.png`,
      themeColor: '#002DA3',
      homeBgPaths: [
        `${BASE_PREFIXS}/images/style/baoxian_shouye_01.png`,
        `${BASE_PREFIXS}/images/style/baoxian_shouye_02.png`,
        `${BASE_PREFIXS}/images/style/baoxian_shouye_03.png`,
      ],
      welcomePageBg: `${BASE_PREFIXS}/images/style/white_welcome.png`,
      title: '欢迎回来',
      subTitle1: '活动运营、数据追踪 ',
      subTitle2: '精准洞察、高效优化',
    },
  };

  selectedImagePath = '';
  platformName = '';
  headerImagePath = '';
  sidebarImagePath = '';
  loginBackgroundPath = '';
  themeColor = '';
  loginLogoPath = '';
  homeBgPaths: string[] = [];
  dynamicFontColor = '';
  welcomePageBg = '';
  title = '';
  subTitle2 = '';
  subTitle1 = '';

  constructor() {
    makeAutoObservable(this);
    this.baseInfo = null;
    this.initUserInfo();
    this.backendStyle();
  }

  initUserInfo = () => {
    const local = sessionStorage.getItem(USER_BASE_INFO);
    if (local === 'undefined') {
      this.baseInfo = {};
    } else if (local) {
      const baseInfo = JSON.parse(local);
      this.baseInfo = baseInfo;
    }
  };

  backendStyle = async () => {
    try {
      const currentDomain = getBackendDomain();
      const response = (await userApi.getBackendStyle({
        backendDomain: currentDomain,
      })) as unknown as {
        backendStyle: string;
        title?: string;
        smsConfigCode?: string;
        logo: string;
        loginLogo: string;
      };
      const { backendStyle, title, smsConfigCode, logo, loginLogo } = response;
      const styleEnum = backendStyle as keyof typeof this.styleConfigs;
      if (smsConfigCode) {
        localStorage.setItem('smsConfigCode', smsConfigCode);
      }
      const styleConfig = this.styleConfigs[styleEnum] || this.styleConfigs['BLUE'];
      this.selectedImagePath = logo || styleConfig.logo[0];
      this.platformName = title || '智慧营销平台';
      this.headerImagePath = styleConfig.headerImage;
      this.sidebarImagePath = styleConfig.sidebarImage;
      this.loginBackgroundPath = styleConfig.loginBackground;
      this.themeColor = styleConfig.themeColor;
      this.loginLogoPath = loginLogo || styleConfig.loginLogo;
      this.homeBgPaths = styleConfig.homeBgPaths;
      this.welcomePageBg = styleConfig.welcomePageBg;
      this.subTitle1 = styleConfig.subTitle1;
      this.subTitle2 = styleConfig.subTitle2;
      this.title = styleConfig.title;
      // 设置动态字体颜色
      this.dynamicFontColor = styleConfig === this.styleConfigs['WHITE'] ? '#000000' : '#FFFFFF';
      // 设置 CSS 变量
      document.documentElement.style.setProperty('--themeColor', this.themeColor);
      document.documentElement.style.setProperty('--dynamicFontColor', this.dynamicFontColor);
    } catch (error) {
      console.error('Failed to fetch backend style:', error);
    }
  };

  // 登录操作
  login = async (params: any, callBackUrl: string) => {
    params.password = md5(params.password);
    const res = await userApi.loginWithPassword(params);
    if (callBackUrl) {
      window.location.href = callBackUrl;
    }
    sessionStorage.setItem(USER_BASE_INFO, JSON.stringify(res));
    this.baseInfo = res;
  };

  // 登录操作
  loginByphone = async (params: any, callBackUrl: string) => {
    const res = await userApi.login(params);
    if (callBackUrl) {
      window.location.href = callBackUrl;
    }
    sessionStorage.setItem(USER_BASE_INFO, JSON.stringify(res));
    this.baseInfo = res;
  };

  // 登出操作
  logout = async () => {
    await userApi.logout();
    sessionStorage.removeItem(USER_BASE_INFO);
    window.location.href = BASE_PREFIX !== '/' ? `${BASE_PREFIX}/login` : 'login';
  };

  getUserInfo = async () => {
    return new Promise((resolve, reject) => {
      userApi
        .getUserInfo()
        .then(async (resp) => {
          resolve(resp);
          // const result = await userApi.getUserModal(resp.id);
          // this.promptInfo = result;
          this.baseInfo = resp;
          sessionStorage.setItem(USER_BASE_INFO, JSON.stringify(resp));
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  setValue = (path: PropertyPath, value: any) => {
    set(this, path, value);
  };
}

const commonStore = new CommonStore();

export default commonStore;
